import type { FormaPagamentoLoja } from "@/api"
import { trocoInsuficiente } from "@/lib/troco"
import type { PassoTotem, RespostaCpfNota } from "@/pages/checkout-final/passos-totem"

export interface DadosFinalizacao {
    nome: string
    pager: string
    pagerConferido: boolean
    respostaCpfNota: RespostaCpfNota
    formaSelecionada?: FormaPagamentoLoja
    trocoRespondido: boolean
    trocoValor: number | null
    total: number
}

export function trocoPendente(dados: DadosFinalizacao): boolean {
    if (dados.formaSelecionada?.forma !== 'DINHEIRO') return false

    return !dados.trocoRespondido || trocoInsuficiente(dados.trocoValor, dados.total)
}

export function passoValido(passo: PassoTotem, dados: DadosFinalizacao): boolean {
    switch (passo) {
        case 'CONSUMO':
            return true
        case 'IDENTIFICACAO':
            return dados.nome.trim().length > 0
        case 'PAGER':
            return dados.pager.trim().length > 0 && dados.pagerConferido
        case 'CPF_NOTA':
            return dados.respostaCpfNota !== null
        case 'PAGAMENTO':
            return !!dados.formaSelecionada && !trocoPendente(dados)
        case 'CONFIRMACAO':
            return true
    }
}

export function podeEnviar(dados: DadosFinalizacao, passos: PassoTotem[]): boolean {
    return passos.every((passo) => passoValido(passo, dados))
}

export function formasDoTotem(formas: FormaPagamentoLoja[] | undefined): FormaPagamentoLoja[] {
    return (formas ?? []).filter((fp) => fp.tipo !== 'ONLINE')
}
